import localFont from 'next/font/local';

const rethinkSansFont = localFont({
  src: [
    {
      path: './rethink-sans-v7-latin-regular.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: './rethink-sans-v7-latin-regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './rethink-sans-v7-latin-500.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './rethink-sans-v7-latin-600.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: './rethink-sans-v7-latin-700.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  display: 'swap',
  variable: '--font-primary',
});

export default rethinkSansFont;
